const reviews = [
  { area: "Website", detail: "Whether the site is clear, credible, and built to convert the right kind of new-patient traffic" },
  { area: "Google Presence", detail: "Visibility, reviews, trust signals, and how the practice appears when prospective patients research options" },
  { area: "New-Patient Pipeline", detail: "Where attention turns into inquiry, and where inquiry may be dropping before scheduling" },
  { area: "Offer & Messaging", detail: "Whether the practice is presenting the right reasons to act now" },
  { area: "Priority Actions", detail: "The specific improvements most likely to matter first" },
];

const CheckupWhatWeReview = () => (
  <section id="what-we-review" className="py-14 md:py-20 bg-background">
    <div className="max-w-4xl mx-auto section-padding">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-3">
          What We Review During the Growth Checkup
        </h2>
        <p className="text-muted-foreground max-w-xl mx-auto text-sm">
          We keep the review practical. The goal is not to overwhelm you with jargon — it's to identify the most important issues first.
        </p>
      </div>

      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.area} className="flex items-start gap-4 bg-card rounded-xl p-5 border border-border">
            <span className="text-accent font-bold text-sm shrink-0 w-36">{r.area}</span>
            <span className="text-sm text-muted-foreground leading-relaxed">{r.detail}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CheckupWhatWeReview;
